import { z } from 'zod'

/**
 * Zod validation schema for candidate information form (Step 1)
 * 
 * Validation rules:
 * - Full Name: Required, minimum 2 characters
 * - Email: Required, valid email format
 * - Phone: Required, international format with country code (E.164 format)
 * - LinkedIn URL: Optional, but must be valid URL if provided
 */
export const candidateInfoSchema = z.object({
  fullName: z
    .string()
    .trim()
    .min(2, 'Please enter your full name'),

  email: z
    .string()
    .trim()
    .toLowerCase()
    .email('Please enter a valid email address'),

  phone: z
    .string()
    .trim()
    .regex(
      /^\+?[1-9]\d{6,14}$/,
      'Please enter a valid phone number with country code (e.g., +55 11 98765-4321)'
    ),

  linkedinUrl: z
    .string()
    .trim()
    .transform((val) => val === '' ? undefined : val)
    .optional()
    .refine(
      (val) => !val || /^https?:\/\/.+/.test(val),
      'Please enter a valid URL (e.g., https://linkedin.com/in/yourname)'
    )
})

/**
 * TypeScript type inferred from the schema
 */
export type CandidateInfoFormData = z.infer<typeof candidateInfoSchema>
